import React, { Component } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Table from './components/Table';
import Form from './components/Form';
import API from '../../services/API';
import Icon from "../../components/Icon";

class PushapiPartners extends Component {
    constructor() {
        super();

        this.state = {
            isLoading: false,
            isShowForm: false,
            sortParam: null,
            sortOrder: 1,
            partners: []
        };

        this.handleAddBtnClick = this.handleAddBtnClick.bind(this);
        this.handleRemoveBtnClick = this.handleRemoveBtnClick.bind(this);
        this.handleFormHide = this.handleFormHide.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleSort = this.handleSort.bind(this);
    }

    componentDidMount() {
        this.loadPartners();
    }

    componentWillUpdate(nextProps, nextState) {
        const { partners, sortParam, sortOrder } = nextState;

        if(this.state.sortParam != sortParam || this.state.sortOrder != sortOrder) {
            this.sortReport(partners, sortParam, sortOrder);

            this.setState({ partners });
        }
    }

    sortReport(partners, sortParam, sortOrder) {
        partners.sort((objA, objB) => {
            if(objA[sortParam] > objB[sortParam]) return 1 * sortOrder;
            else if(objA[sortParam] < objB[sortParam]) return -1 * sortOrder;

            return 0;
        });
    }

    loadPartners() {
        this.setState({ isLoading: true });

        API.PushapiPartners.get().then(partners => this.setState({ partners, isLoading: false }));
    }

    handleAddBtnClick() {
        this.setState({ isShowForm: true });
    }

    handleFormHide() {
        this.setState({ isShowForm: false, partnerToUpdate: null });
    }

    handleFormSubmit(partner) {
        this.setState({
            isShowForm: false,
            isLoading: true
        });

        API.PushapiPartners.save(partner).then(() => this.loadPartners());
    }

    handleRemoveBtnClick(id) {
        this.setState({ isLoading: true });

        API.PushapiPartners.remove(id).then(() => this.loadPartners());
    }

    handleSort(param) {
        const { sortParam, sortOrder } = this.state;

        if(sortParam === null) this.setState({ sortParam: param });
        else if(param === sortParam) this.setState({ sortOrder: sortOrder * -1 });
        else this.setState({ sortParam: param, sortOrder: 1 });
    }

    getForm() {
        if(this.state.isShowForm) {
            return <Form
                onSubmit={this.handleFormSubmit}
                onFormHide={this.handleFormHide}
                partner={this.state.partnerToUpdate}
            />;
        }
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="Pushapi Partners"/>
                <Row>
                    <Col lg={12}>
                        <div className="pull-right m-b-15">
                            <Button bsStyle="success" onClick={this.handleAddBtnClick}><Icon name="plus"/> Add</Button>
                        </div>
                    </Col>
                </Row>

                {this.getForm()}

                <Table partners={this.state.partners} onRemove={this.handleRemoveBtnClick} onSort={this.handleSort}/>
            </Container>
        );
    }
}

export default PushapiPartners;


// WEBPACK FOOTER //
// ./src/scenes/PushapiPartners/index.js